<div class="mt-2" *ngIf="model && model.data && model.data.length === 0" style="color: rgba(0, 0, 0, 0.25);">
  {{'NO-TASKS' | translate}}</div>
<div class="row w-100" *ngIf="model && model.data">
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-10 col-xl-10 pt-3 pb-3 d-flex" style="max-width: 350px;"
    *ngFor="let data of model.data">
    <ng-template [ngTemplateOutlet]="cardTemplate" [ngTemplateOutletContext]="{data:data}">
    </ng-template>
  </div>
</div>

<!--Render Card View-->
<ng-template #cardTemplate let-data='data'>
  <div class="card card-shadow">
    <div class="card-body pt-2">
      <div class="card-title">
        <div class="row">
          <div class="col-9">
            <div class="row pl-2 assignee-name montserrat overflow-hidden k-text-ellipsis">{{data.assigneeName}}</div>
          </div>
          <div class="col-3 p-0 text-right">
            <a *ngIf="messagesEnabled" class="pointer pr-2" (click)="sendMessageToAssignee(data.assignee)">
              <i title="{{'COMPOSE'|translate}}" class="fas fa-envelope fa-lg compose-icon"></i>
            </a>
            <a class="pointer pr-2" (click)="addTaskForAssignee(data.assignee)">
              <i title="{{'ADD-TASK'|translate}}" class="fas fa-check-square fa-lg add-task-icon"></i>
            </a>
          </div>
        </div>
        <div *ngIf="data.assigneeTeamRole" class="row role-name">({{data.assigneeTeamRole}})</div>
        <div *ngIf="!data.assigneeTeamRole && data.userRoleName" class="row role-name">({{data.userRoleName}})</div>
      </div>
      <div class="mt-2">
        <i class="far fa-check-square"></i>&nbsp;
        <span [translate]="getAssignTranslationKey(data)" [translateParams]="{value: data.assignedTasks}"></span>
        <br />
        <i class="fas fa-exclamation-circle" [ngClass]="{'task-late': data.lateTasks > 0}"></i>&nbsp;
        <span translate [translateParams]="{value: data.lateTasks}">{{data.lateTasks === 1 ? 'TASK-CARD-VIEW-TASK-LATE'
          : 'TASK-CARD-VIEW-TASKS-LATE'}}</span>
        <br />
        <i class="fas fa-exclamation-circle"></i>&nbsp;
        {{'TASK-CARD-VIEW-NEXT-TASK-DUE' | translate}}:&nbsp;
        <span class="emphasizedLabel text-capitalize" *ngIf="data.nextTaskDueDate">{{data.nextTaskDueDateText}}</span>
      </div>
      <hr>
      <div class="card-detail">
        <table class="table table-hover">
          <tbody>
            <tr *ngFor="let task of data.tasks; let i = index;">
              <td>
                <div class="col-12 pt-2 pl-2 pr-2">
                  <div class="small-priority-badge mr-2" [ngClass]="[task.priorityBadgeClass]">
                    {{task.priority.charAt(0)}}
                  </div>
                  <a tabindex="i" (click)="openTask(task)" class="pointer mt-2 task-name"
                    [ngClass]="{'task-late': task.isLate}">
                    <span [ngClass]="{'completed-task': task.status === 'Completed'}">{{task.name}}</span>
                  </a>
                  <br />
                  <div class="task-info pb-2">
                    {{'OPENED' | translate }}:&nbsp;{{ intl.formatDate(intl.parseDate(task.openedOn), "d")}}
                    <span *ngIf="task.dueDate">&nbsp;{{'DUE-ON' | translate }}:&nbsp;{{
                      intl.formatDate(intl.parseDate(task.dueDate), "d")}}
                    </span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>